/* eslint-disable max-len */

import angular from 'angular';

export default function EditControlTypeDialogController(
  $q,
  $rootScope,
  $scope,
  $timeout,
  copy,
  ssDialogService,
  alerts,
  loaderService,
  controlSharedModelService,
) {
  const vm = this;

  vm.handleCloseDialogClick = _handleCloseDialogClick;
  vm.handleEditControlSubmit = _handleEditControlSubmit;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    vm.newControlType = angular.copy(vm.controlType);
    saveDefaultValue();
  }

  function _handleCloseDialogClick() {
    ssDialogService.hide(ssDialogService.dialogs.controlAdmin.editControlTypeDialog);
  }

  function _handleEditControlSubmit() {
    $scope.editControlTypeForm.$submitted = true;
    loaderService.showViewLoader = true;

    if (!$scope.editControlTypeForm.$valid) {
      loaderService.showViewLoader = false;
      return false;
    }
    if ($scope.editControlTypeForm.$valid) {
      loaderService.showViewLoader = true;
      vm.controlType.createdDate = new Date();
      vm.controlType.controlPreventiveEffectivenessId = vm.controlType.controlPreventiveEffectiveness.controlPreventiveEffectivenessId;
      vm.controlType.controlDetectiveEffectivenessId = vm.controlType.controlDetectiveEffectiveness.controlDetectiveEffectivenessId;
      vm.controlType.controlCorrectiveEffectivenessId = vm.controlType.controlCorrectiveEffectiveness.controlCorrectiveEffectivenessId;
      vm.controlType.controlAdministrativeNatureId = vm.controlType.controlAdministrativeNature.controlAdministrativeNatureId;
      vm.controlType.controlTechnicalNatureId = vm.controlType.controlTechnicalNature.controlTechnicalNatureId;
      vm.controlType.controlPhysicalNatureId = vm.controlType.controlPhysicalNature.controlPhysicalNatureId;
      vm.controlType.controlPrimaryControlTypeId = vm.controlType.controlPrimaryControlType.controlPrimaryControlTypeId;
      vm.controlType.controlCompensatingControlTypeId = vm.controlType.controlCompensatingControlType.controlCompensatingControlTypeId;
      // if (vm.controlType.controlReviewSchedule) {
      //   vm.controlType.controlReviewScheduleId = vm.controlType.controlReviewSchedule.controlReviewScheduleId;
      // }

      return _saveControlType()
        .then(() => {
          // _broadcastChanges();
          $rootScope.$broadcast('refreshControlTypes', { controlType: vm.savedControlType });
          switch (vm.saveType) {
            case 'saveAndClose':
              $rootScope.$broadcast('refreshAssetTypes');
              loaderService.showViewLoader = false;
              alerts.success('The control type has been saved successfully.');
              _closeDialog();
              break;
            case 'saveAndAddAnother':
              loaderService.showViewLoader = false;
              alerts.success('The control type has been saved successfully.');
              _resetViewModel();
              break;
            default:
              loaderService.showViewLoader = false;
          }
        });
    }
  }

  // function _broadcastChanges() {
  //   $rootScope.$broadcast('refreshControlTypes', { controlType: vm.savedControlType });
  // }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.controlAdmin.editControlTypeDialog);
  }

  function _resetViewModel() {
    $timeout(
      () => {
        vm.controlType.newName = '';
        vm.controlType.name = '';
        vm.controlType.customerControlTypeId = 0;
        resetDefaultValue();
        $scope.editControlTypeForm.$setPristine();
        $scope.editControlTypeForm.$setUntouched();
        $timeout(
          () => {
            angular.element('#dialogContent_editControlTypeDialog')[0].scrollTop = 0;
          }, 0
        );
      },
      100
    );
  }

  function _saveControlType() {
    return controlSharedModelService.saveControlType(vm.controlType)
      .then((response) => {
        vm.customerControlTypeId = response.customerControlTypeId;
        vm.savedControlType = response;
      });
  }

  function saveDefaultValue() {
    vm.controlPreventiveEffectivenessOld = angular.copy(vm.controlType.controlPreventiveEffectiveness);
    vm.controlDetectiveEffectivenessOld = angular.copy(vm.controlType.controlDetectiveEffectiveness);
    vm.controlCorrectiveEffectivenessOld = angular.copy(vm.controlType.controlCorrectiveEffectiveness);
    vm.controlAdministrativeNatureOld = angular.copy(vm.controlType.controlAdministrativeNature);
    vm.controlTechnicalNatureOld = angular.copy(vm.controlType.controlTechnicalNature);
    vm.controlPhysicalNatureOld = angular.copy(vm.controlType.controlPhysicalNature);
    vm.controlPrimaryControlTypeOld = angular.copy(vm.controlType.controlPrimaryControlType);
    vm.controlCompensatingControlTypeOld = angular.copy(vm.controlType.controlCompensatingControlType);
    // vm.controlReviewScheduleOld = angular.copy(vm.controlType.controlReviewSchedule);
  }

  function resetDefaultValue() {
    vm.controlType.controlPreventiveEffectiveness = angular.copy(vm.controlPreventiveEffectivenessOld);
    vm.controlType.controlDetectiveEffectiveness = angular.copy(vm.controlDetectiveEffectivenessOld);
    vm.controlType.controlCorrectiveEffectiveness = angular.copy(vm.controlCorrectiveEffectivenessOld);
    vm.controlType.controlAdministrativeNature = angular.copy(vm.controlAdministrativeNatureOld);
    vm.controlType.controlTechnicalNature = angular.copy(vm.controlTechnicalNatureOld);
    vm.controlType.controlPhysicalNature = angular.copy(vm.controlPhysicalNatureOld);
    vm.controlType.controlPrimaryControlType = angular.copy(vm.controlPrimaryControlTypeOld);
    vm.controlType.controlCompensatingControlType = angular.copy(vm.controlCompensatingControlTypeOld);
    // vm.controlType.controlReviewSchedule = angular.copy(vm.controlReviewScheduleOld);
  }
}

EditControlTypeDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  '$timeout',
  'copy',
  'ssDialogService',
  'alerts',
  'loaderService',
  'controlSharedModelService',
];
